<template>
    <div class="bg-white" style="background-color: white; min-height: 100vh; padding-bottom: 20px;">
        <CContainer>
            <br />
            <CRow class="header-row mb-3 position-relative">
                <!-- Back Button on the Left -->
                <CCol class="col-auto">
                    <CButton class="back-button" @click="goBack">
                        ←
                    </CButton>
    
                </CCol>
    
                <!-- Centered Title -->
                <CCol class="d-flex flex-column align-items-center position-absolute start-50 translate-middle-x">
                    <h3 class="section-title m-0">Notification Preferences</h3>
                </CCol>
            </CRow>
            <div class="w-100 mt-5">
                <br />
                <CContainer>

                    <div v-for="(section, index) in notifications" :key="index" class="mb-3">
      <h6 class="text-muted mt-2">{{ section.title }}</h6>
      <CRow v-for="(item, idx) in section.items" :key="idx" class="align-items-center mb-2">
        <CCol class="font-color-191919 mt-2">{{ item.label }}</CCol>
        <CCol class="text-right">
          <CSwitch v-model="item.enabled" color="primary" shape="pill"/>
        </CCol>
      </CRow>
    </div>
                   
    <br /><br /><br /><br />
    
    
    
                </CContainer>
                <Footerlayout />
            </div>
        </CContainer>
    
    </div>
</template>


<script>
import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";

export default {
    components: {
        Mainlayout,
        Footerlayout,
    },
    data() {
        return {
            notifications: [
        {
          title: "Special tips and offers",
          items: [
            { label: "New survey opportunities", enabled: false },
            { label: "Voucher expiry reminders", enabled: false },
            { label: "Company announcements", enabled: false }
          ]
        },
        {
          title: "Personal Notifications",
          items: [
            { label: "Survey results", enabled: false },
            { label: "Voucher updates", enabled: false }
          ]
        },
        {
          title: "Public Updates",
          items: [
            { label: "New surveys", enabled: false },
            { label: "Trending vouchers", enabled: false }
          ]
        }
      ]
        }
    },
    methods: {
        goBack() {
            this.$router.push("Home"); // Navigate to the previous page
        },
        openPopup(video) {
            this.selectedVideo = video;
            this.isPopupDetail = true;
        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        deleteVideo() {
            this.isPopupDelete = true;
        },
        shareVideo() {
            this.isPopupShareLink = true;
        },
        openSuccess() {
            this.isPopupSuccess = true;
            this.isPopupDelete = false;
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            }
        }
    }
};
</script>
<style scoped>
.notification-settings {
  max-width: 400px;
  margin: auto;
}

</style>

